module.exports = __webpack_public_path__ + "portrait-girl.a5353d6.png";